/// <amd-module name="VSSUI/ResponsiveViewport" />
export * from "./Components/ResponsiveViewport/index";
